<template>
    <section id="unsaved-changes">
        <b-modal 
            @hide="onHide" 
            id="unsaved-changes-modal" 
            ref="unsavedChanges" 
            hide-header 
            hide-footer>
                <div class="unsaved-changes mx-auto d-flex align-items-center justify-content-center flex-column">
                    <div class="text-center">
                        <div data-name="modal-title">
                            <p>{{title}}</p>
                        </div>
                        <div data-name="modal-desc">
                            <p>{{text}}</p>
                        </div>
                    </div>
                    <div data-name="action-buttons" class="d-flex align-items-center">
                        <div data-name="no">
                            <p 
                                id="close-btn"
                                @click="$emit('no')"
                                class="mb-0">
                                    No
                            </p>
                        </div>
                        <Button
                            id="save-btn"
                            :disabled="loading"
                            @click.native="$emit('submit')"
                            type="primary">
                                {{saveText}}
                        </Button>
                    </div>
                </div>
        </b-modal>
    </section>
</template>

<script>
import Button from '../components/Theme/Button'

export default {
    name: 'UnsavedChanges',
    components: {
        Button
    },
    mounted: function() {
        this.$bvModal.show('unsaved-changes-modal')
    },
    props: {
        loading: Boolean,
        title: {
            type: String,
            default: 'You have unsaved changes'
        },
        text: {
            type: String,
            default: 'Do you want to keep them?'
        },
        saveText: {
            type: String,
            default: 'Save'
        }
    },
    methods: {
        onHide: function(evt) {
            this.$bvModal.hide('unsaved-changes-modal')
            setTimeout(() => {
                this.$emit('close')
            })
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

div.unsaved-changes {
    width: 450px;
    height: 313px;
    background: #FFFFFF;
    box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);
    border-radius: 5px;

    div[data-name="modal-title"] {
        p {
            color: $c6;
            font-size: $p2;
            font-weight: $weight_bold;
        }
    }
    div[data-name="modal-desc"] {
        p {
            color: $c21;
            font-size: $p3;
        }
    }
    div[data-name="action-buttons"] {
        margin-top: 72px;
        div[data-name="no"] {
            p {
                color: $c1;
                font-size: $p3;
                font-weight: $weight_bold;
                cursor: pointer;
                transition: all 0.1s ease;
    
                &:hover {
                    text-decoration: underline;
                }
            }
        }

        button {
            padding-left: 57px;
            padding-right: 57px;
            padding-top: 12px;
            padding-bottom: 12px;
            margin-left: 95px;
        }
    }

}
</style>